<template>
  <div class="journal-page">
    <journalSideBar @clickInNode="clickInNavigatorNode"
    />
    <div v-if="$route.name === 'journal'" class="journal-content">
      <thingsFirst class="journal-things"
                   :class="{'things-body_close': !showJournalSidebar}"
                   :journalsPages="$route.name === 'journal' || $route.name === 'journalThingsInProject' || $route.name === 'journalThingsInProjectItem'"
                   :journalsPage="$route.name === 'journal'"/>
    </div>
    <div v-else-if="$route.name === 'journalThingsInProject' || $route.name === 'journalThingsInProjectItem' || $route.name === 'journalMultithingInProject'" class="journal-content">
      <thingsFirst class="journal-things"
                   :class="{'things-body_close': !showJournalSidebar}"
                   :journalsPages="$route.name === 'journal' || $route.name === 'journalThingsInProject' || $route.name === 'journalThingsInProjectItem'"
                   :journalMultithingPage="$route.name === 'journalMultithingInProject'"/>
    </div>
    <div v-else class="journal-content">
      <journalHeader/>
      <journalBody/>
    </div>
    <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

    </p>
  </div>
</template>

<script>
  import journalSideBar from '../../components/Pages/Journal/journalSidebar'
  import journalHeader from '../../components/Pages/Journal/journalHeader'
  import journalBody from '../../components/Pages/Journal/journalBody'
  import editEvent from '../../components/Pages/Journal/editEvent'
  import {loaderMixin} from "../../mixins/utils/loaderMixin";
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import {mapActions, mapMutations, mapState} from "vuex";
  import thingsFirst from "../../components/Pages/Things/Things/thingFirstLevel";
  import {journalSidebar} from '../../mixins/journalSidebar'

  export default {
    name: "Journal",
    mixins: [loaderMixin, tokenAndRoute, journalSidebar],
    components: { journalSideBar, journalHeader, journalBody, editEvent, thingsFirst },
    computed: {
      ...mapState({
        openNavigator: state => state.openProjectsNavigator
      }),
      isNotJournalsMain() {
        return this.$route.name !== 'journal' && this.$route.name !== 'journalThingsInProject' && this.$route.name !== 'journalThingsInProjectItem' && this.$route.name !== 'journalMultithingInProject'
      }
    },
    methods: {
      ...mapActions({
        getEvents: 'journal/getEvents',
        getEventTemplates: 'journal/getEventTemplates',
        getUsers: 'roles/getUsers',
        getRoles: 'roles/getOwnedRoles',
        getInvitedUsers: 'roles/getInvitedUsers',
        getOwnedDevices: 'things/getDevices',
      }),
      ...mapMutations({
        setDirName: 'things/SET_DIR_NAME',
        setDashboard: 'sidebar/SET_DASHBOARD',
        setFullSidebar: 'sidebar/SET_DASHBOARD',
        setLinkName: 'sidebar/SET_LINK_NAME',
        setRouteName: 'sidebar/SET_ROUTE_NAME'
      }),
      clickInNavigatorNode(node) {
        let id = node.id;
        this.setDirName(node.name)
        let projectId
        let treeItem
        let findParent = (item) => {
          treeItem = item.parent
          if (item.parent.id !== 0) {
            projectId = item.parent.id
            findParent(treeItem)
          }
        }

        findParent(node)

        if (node.isMother) {
          this.$router.push(`/journals/project/${id}`)
        } else {
          this.$router.push(`/journals/project/${projectId}/project-item/${id}`)
        }
      }
    },
    watch: {
      routeId() {
        if (this.isNotJournalsMain) {
          const param = {
            id: this.$route.params.id
          }
          this.showLoader();
          this.getEvents(param)
          this.getEventTemplates(this.$route.params.id)
          this.hideLoader();
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        vm.setDashboard(true)
        if (vm.isNotJournalsMain) {
          const param = {
            id: vm.$route.params.id
          }
          vm.showLoader();
          await vm.getEvents(param)
          await vm.getEventTemplates(vm.$route.params.id)
          vm.hideLoader();
        } else {
          const token = localStorage.getItem('token');

          vm.showLoader();
          await vm.getUsers(token);
          await vm.getInvitedUsers(token);
          await vm.getRoles({token, id: ''});
          await vm.getOwnedDevices();


          vm.setFullSidebar(false);
          // vm.setLinkName('home');
          vm.setRouteName(vm.$t('index.journal.title'));
          vm.hideLoader();
        }
      })
    },
    beforeRouteUpdate(to, from, next) {
      if ( to.name === 'journal') {
        this.setFullSidebar(false);
        // this.setLinkName('home');
        this.setRouteName(this.$t('index.journal.title'));
      }
      next();
    }
  }
</script>

<style lang="scss" scoped>
  .journal-page {
    /*padding-top: 90px;
    padding-left: 240px;
    padding-bottom: 50px;*/
    background-color: #EFF3F6;
    display: flex;
    /*margin-top: -30px;
    margin-left: -30px;
    margin-right: -30px;*/
    min-height: calc(100vh + 30px);
    height: auto;
    transition: all .25s;
    padding: 90px 0 0 240px;

    &.show-small-sidebar {
      padding: 90px 0 0 60px;
    }
  }
  .journal-content {
    width: 100%;
  }

  .journal-things {
    margin-left: 260px;
    position: relative;
    height: 100%;

    @media screen and (max-width: 1500px) {
      margin-left: 250px;
    }

    @media screen and (max-width: 1370px) {
      margin-left: 200px;
    }
  }

  .things-body_close {
    margin-left: 70px;
  }

</style>
